import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import {AppConfig} from '../../app.config';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject }    from 'rxjs/Subject';
@Injectable()
export class AssignmentService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    saveAssignment(assignment: any) {
      return this.http.post(this.config.apiUrl +'assignment/create', assignment, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllAssignment(assignmentCurrentPage: number, maxSize: any,filter:any,isExport:any) {
        return this.http.post(this.config.apiUrl +'assignment/get-all?page='+assignmentCurrentPage+'&limit='+maxSize+'&isExport='+isExport,filter, this.setHeaders()).map((response: Response) => response.json());
    }
    // getAllActiveAssignment() {
    //     return this.http.get(this.config.apiUrl +'/v1/lead/get-all-active', this.setHeaders()).map((response: Response) => response.json());
    // }
    deleteAssignment(id: any) {
         return this.http.post(this.config.apiUrl +'assignment/delete',id, this.setHeaders()).map((response: Response) => response.json());
    }
    getAssignmentById(id:any) {
        return this.http.post(this.config.apiUrl+ 'assignment/find-by-id',{id:id},this.setHeaders()).map((response:Response)=>response.json());
    }
    updateAssignment(assignment:any) {
        return this.http.post(this.config.apiUrl +'assignment/update', assignment, this.setHeaders()).map((response: Response) => response.json());
    }
    findAssignmentActivityByAssignmentId(assignment_id:any) {
      return this.http.get(this.config.apiUrl + 'assignmentActivity/get-by-assignment-id/'+assignment_id,this.setHeaders()).map((response: Response) => response.json());
    }
    getAssiNotificationDetail(reqData: any) {
        return this.http.post(this.config.apiUrl + 'notification/assignment', reqData, this.setHeaders())
            .map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if(params)
                return new RequestOptions({ headers: headers , search : params });
            else
                return new RequestOptions({ headers: headers });
        }else{
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/assignment.service.ts